import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import Menu from "./components/Menu/Menu";

// Direct imports instead of lazy loading
import Home from "./pages/Home/Home";
import Work from "./pages/Join Us/Work";
import Project from "./pages/Project/Projects";
import About from "./pages/About Us/About";
import Contact from "./pages/Get In Touch/Contact";
import Services from "./pages/Services/Services";
import AllProjects from "./pages/All-Projects/All-Projects";
import SingleProject from "./pages/Single Project/SingleProject";

// Admin imports
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminGate from "./pages/Admin/AdminGate";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1400);
  }, [pathname]);

  return null;
}

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Reset overflow for admin routes
  useEffect(() => {
    if (isAdminRoute) {
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflowY = 'auto';
      document.body.style.overflowY = 'auto';
    }
  }, [isAdminRoute]);

  return (
    <>
      {!isAdminRoute && <Menu />}
      <ScrollToTop />
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/join-us" element={<Work />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Project />} />
          <Route path="/all-projects/:category" element={<AllProjects />} />
          <Route path="/all-projects/:category/:projectName" element={<SingleProject />} />
          
          {/* Admin Routes - Protected by AdminGate */}
          <Route path="/admin" element={
            <AdminGate>
              <AdminLogin />
            </AdminGate>
          } />
          <Route path="/admin/dashboard" element={
            <AdminGate>
              <AdminDashboard />
            </AdminGate>
          } />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
